import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { PersonalStory } from './components/PersonalStory';
import { Breakthrough } from './components/Breakthrough';
import { Science } from './components/Science';
import { VisualMetaphor } from './components/VisualMetaphor';
import { Testimonials } from './components/Testimonials';
import { Timeline } from './components/Timeline';
import { ProductComparison } from './components/ProductComparison';
import { Ingredients } from './components/Ingredients';
import { Credibility } from './components/Credibility';
import { Pricing } from './components/Pricing';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-[#FFF8F3] font-['Inter']" data-id="element-0">
      <Header data-id="element-1" />
      <main className="max-w-[1200px] mx-auto px-6 pb-24" data-id="element-2">
        <Hero data-id="element-3" />
        <OpeningHook data-id="element-4" />
        <PersonalStory data-id="element-5" />
        <Breakthrough data-id="element-6" />
        <Science data-id="element-7" />
        <VisualMetaphor data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Timeline data-id="element-10" />
        <ProductComparison data-id="element-11" />
        <Ingredients data-id="element-12" />
        <Credibility data-id="element-13" />
        <Pricing data-id="element-14" />
        <Offer data-id="element-15" />
        <FAQ data-id="element-16" />
        <FinalCTA data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
    </div>;
}